module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    attrs: {
      "id": "chat-companion"
    }
  }, [_c('ul', {
    attrs: {
      "id": "chat-companion-switcher"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return (!tab.requiresLogin || _vm.isLoggedIn) ? _c('li', {
      class: {
        selected: _vm.activeTab === tab.label
      },
      on: {
        "click": function($event) {
          _vm.activeTab = tab.label
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.label) + "\n            "), (tab.notificationType === 'badge' && tab.showNotification) ? _c('i', {
      staticClass: "fas fa-bell"
    }) : _vm._e(), _vm._v(" "), (tab.notificationType === 'total' && tab.showNotification) ? _c('i', {
      staticClass: "total-notification"
    }, [_vm._v(_vm._s(tab.notificationCount))]) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), (_vm.activeTab === 'Chatroom') ? _c('chat-companion') : _vm._e(), _vm._v(" "), (_vm.activeTab === 'Private Chat') ? _c('private-chat-companion', {
    ref: "privateChat"
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'Online Users') ? _c('online-users-companion') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36e6a6a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/ChatCompanion.vue
// module id = 850
// module chunks = 2